import _ from 'lodash'
import Vue from 'vue'
import qs from 'qs'
import axios from 'axios'
import RequestTracker from '../../functions/RequestTracker'
import store from '../index'

const apiCall = ({ url, method, ...args }) => new Promise((resolve, reject) => {
  let axiosHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }

  const authToken = store.getters.authToken

  if (!_.isEmpty(authToken)) {
    axiosHeaders['Authorization'] = 'Bearer ' + authToken
  }

  if (args.qs) {
    url = url + '?' + qs.stringify(args.qs)
  }

  let withHeaders = args.withHeaders === true
  if (withHeaders && args.responseType !== 'json') {
    args.responseType = 'blob'
  }

  if (args.responseType === undefined) {
    args.responseType = 'json'
  }

  let requestCancelToken = RequestTracker.addPendingRequest(url, method || 'GET')

  const URL = process.env.ROOT_API

  Vue.prototype.$api({
    timeout: 300000,
    method: method || 'GET',
    baseURL: URL + '/api/v1',
    url: url,
    headers: axiosHeaders,
    data: args.data,
    responseType: args.responseType,
    ...(!_.isNull(requestCancelToken) ? { cancelToken: requestCancelToken } : {})
  }).then(response => {
    store.dispatch('updateLastActivity')

    if (response.data.hasOwnProperty('2fa')) {
      store.dispatch('toggle2fa', response.data['2fa'])
    }

    if (withHeaders) {
      resolve(response)
    } else {
      resolve(response.data)
    }
  }).catch(err => {
    if (!axios.isCancel(err)) {
      reject(err)
    }
  })
})

export default apiCall



// WEBPACK FOOTER //
// ./src/store/modules/call.js